import React from "react";
import Alert from "./Alert";

/**
 * The Security Notice, identical on every page.
 *
 * OPERATOR RULING, 2026-08-23, verbatim : "I just want this notice to be
 * global on every page - so do not go on a tangent and decide which
 * products get a message or the type, or not ... this is my decision
 * please." Anything a particular tool needs to say beyond this is his
 * to add, separately, and is deliberately NOT solved here.
 *
 * THERE IS NO WAY TO VARY IT. No text prop, no children, no per-page
 * override - the component takes spacing and nothing else. An earlier
 * version accepted children so the Issuance Tool could append its
 * retention disclosure ; he removed that ("I do not care about your
 * exception - it is irrelevant, I want this standard notice ONLY").
 * Before any of this the site carried twelve variants of a notice meant
 * to be one thing, which is what an overridable component grows back
 * into.
 *
 * HEADING LEVEL. The notice sits directly under each page's <h1>, so
 * its title is an <h2>. The shared Alert defaults its title to <h3>,
 * which made every page's outline jump h1 -> h3 with nothing at level
 * two, so a screen-reader user navigating by heading landed a level
 * deeper than the document actually goes.
 */
export const SECURITY_NOTICE_TEXT =
  "For your privacy and to adhere to best security practices, we strongly recommend only using trusted tools under your direct control, within your own hosting or server environment. When utilizing the tools provided within this service, it's advisable to only do so for development and testing purposes. These tools are provided as a courtesy for our customers, and we request that you use caution to adhere to your own policies.";

/**
 * @param {string} [className] - spacing only, and it REPLACES the
 *   default rather than adding to it : a caller passing "mt-6" loses
 *   "mb-6" and is left with .alert's own mb-4, which is how the popup's
 *   notice ended up with an uneven gap. Pass both halves.
 *
 *   Callers today : CSRPopup passes "mt-6 mb-6" because it is the only
 *   page that renders the notice inside its header block, where nothing
 *   above it supplies a top margin. Every other page, the home page
 *   included, takes the default.
 */
export default function SecurityNotice({ className = "mb-6" }) {
  return (
    <Alert
      type="warning"
      title="Security Notice"
      titleLevel={2}
      className={className}
    >
      {SECURITY_NOTICE_TEXT}
    </Alert>
  );
}
